import { getMessageGroupById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetMessageGroupByIdQuery = (messageGroupId, enabled = true) =>
    useQuery({
        queryKey: ['message_group', messageGroupId],
        queryFn: async () => getMessageGroupById(messageGroupId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetMessageGroupByIdQuery;
